import {useEffect} from "react";
import axios from "axios";

export default function Logout() {
    useEffect(async () => {
        const {data} = await axios.get('/api/v2/users/isAuthenticated');

        if (data.isAuthenticated)
            await axios.post('/api/v2/users/logout');

        window.location.href = "/login";
    }, []);

    return null;
}